export default __webpack_public_path__ + "static/media/logo.6876a8c2.png";